import { Dispatch } from 'redux';
import { ConfirmationDialogState } from '../types/state';

export const CONFIRMATIONDIALOGACTIONS = {
  OPEN: 'CD_OPEN',
  CLOSE: 'CD_CLOSE',
};

type OpenConfirmatioDialogData = Partial<ConfirmationDialogState>;

export const confirm =
  (dialogData: OpenConfirmatioDialogData) => (dispatch: Dispatch) => {
    dispatch({
      type: CONFIRMATIONDIALOGACTIONS.OPEN,
      payload: dialogData,
      meta: {
        track: true,
      },
    });
  };

export const closeConfirmationDialog = () => (dispatch: Dispatch) => {
  dispatch({
    type: CONFIRMATIONDIALOGACTIONS.CLOSE,
    meta: {
      track: true,
    },
  });
};
